import React, {useRef} from 'react'
import NavigationSection from "../../../../core/model2/navigation/navigation-section";
import {NavigationButtonPosition, NavigationSectionType} from "../../../../core/model2/navigation/@const";
import ErrorBoundary from "../../../../core/error-boundary";
import {NavigationButtonTypeClass} from "../../../navigation/@const";
import NavigationPanelReorderGroup from "../../../navigation/components/reorder-group/reorder-group";
import Navigation_Separator from "../../../navigation/buttons/separator";
import Navigation_ButtonUpgrade from "../../../navigation/buttons/upgrade";
import Navigation_MyAccountBtn from "../../../navigation/buttons/my-account";
import NavigationLogo from "../../../navigation/components/logo/logo";
import NavigationPanel_PinnedViews from "../../../navigation/components/pinned-views/views";
import Navigation_ButtonSpace from "../../../navigation/buttons/generic-space";

type Props = {
    onDragNavigationSectionsEnd : callback
    className?                  : string
    navWidth                    : number
}

// const debug = "UIModern_NavigationPanel_User"
const debug = false

export default function UIModern_NavigationPanel_User(props: Props) {

    const leftSectionRef    = useRef<HTMLDivElement>(null)
    debug && console.log(debug, "Render()")

    // extract home section, it is rendered separately and should not present among reorderable items
    const homeSection   = gd.spaces.home.navigation



    const aiChat        = gd.navigationStructure.aiChat

    const onReorder = (navigationSections: NavigationSection[]) => {
        debug && console.log(debug, "onReorder", navigationSections)

        gd.spaces.saveSpacesOrder(navigationSections)
    }

    const onViewsReorder = (navigationSections: NavigationSection[]) => {
        debug && console.log(debug, "onViewsReorder", navigationSections)

        props.onDragNavigationSectionsEnd(1, navigationSections)
    }

    return (
        <>
            <div ref={leftSectionRef} className="top">
                <div className="top-container">

                    <NavigationLogo/>


                    <ErrorBoundary>
                        <gd.spaces.home.navigation.renderComponent className={NavigationButtonTypeClass.IS_TAB} section={homeSection} />

                        <NavigationPanelReorderGroup sections={gd.spaces.navigationPanelTopSpacesAsNavigations} onDragEnd={onReorder} />

                        <Navigation_Separator/>

                        <NavigationPanel_PinnedViews onDragEnd={onViewsReorder}/>

                        <gd.navigationStructure.more.renderComponent section={gd.navigationStructure.more}/>

                        {gd.spaces.quickAdd.inNavigationPanel &&
                            <gd.spaces.quickAdd.navigation.renderComponent section={gd.spaces.quickAdd.navigation}/>
                        }


                    </ErrorBoundary>
                </div>
            </div>

            <div className="bottom">

                {gd.ui.showUpgrade &&
                    <Navigation_ButtonUpgrade/>
                }

                {aiChat && gd.spaces.aiChat.inNavigationPanel &&
                    <Navigation_ButtonSpace space={gd.spaces.aiChat} />
                }

                {gd.spaces.search.inNavigationPanel && (
                    <gd.spaces.search.navigation.renderComponent section={gd.spaces.search.navigation}/>)
                }

                <Navigation_MyAccountBtn className="m-t-8" />
            </div>

        </>
    )
}
